import { GET_PAYOUT, GET_PAYOUTS } from "../Action/type";

const initialState = {
  payoutList: [],
  count: 0,
  payout: ''
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_PAYOUTS:
      return {
        ...state,
        payoutList: payload.payoutRequests,
        count: payload?.count,
      };

    case GET_PAYOUT:
      return {
        ...state,
        payout: payload
      };  

    default:
      return state;
  }
}
